module.exports = __webpack_public_path__ + "img/graphic-3.26f2581e.png";